import React, { useEffect, useState } from 'react';

const SPOTIFY_TRACK_ID = '56aJDJEYj9RTd5RzdCp2tW';
const SPOTIFY_WEB_URL = `https://open.spotify.com/track/${SPOTIFY_TRACK_ID}`;

const AfternoonLanding = () => {
  const [language, setLanguage] = useState('es');
  const [redirecting, setRedirecting] = useState(true);

  const messages = {
    es: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Abriendo Spotify...',
      button: 'Escuchar en Spotify',
      fallback: 'Si no se abre automáticamente, haz clic aquí:',
      explore: 'Explorar más música',
    },
    en: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Opening Spotify...',
      button: 'Listen on Spotify',
      fallback: 'If it doesn\'t open automatically, click here:',
      explore: 'Explore more music',
    },
    pt: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Abrindo Spotify...',
      button: 'Ouvir no Spotify',
      fallback: 'Se não abrir automaticamente, clique aqui:',
      explore: 'Explorar mais música',
    },
    fr: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Ouverture de Spotify...',
      button: 'Écouter sur Spotify',
      fallback: 'Si Spotify ne s\'ouvre pas automatiquement, cliquez ici :',
      explore: 'Explorer plus de musique',
    },
    de: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Spotify wird geöffnet...',
      button: 'Auf Spotify anhören',
      fallback: 'Wenn es nicht automatisch öffnet, klicke hier:',
      explore: 'Mehr Musik entdecken',
    },
    it: {
      title: 'Afternoon with Myself',
      subtitle: 'SYNTETIK',
      redirecting: 'Apertura di Spotify...',
      button: 'Ascolta su Spotify',
      fallback: 'Se non si apre automaticamente, clicca qui:',
      explore: 'Esplora più musica',
    },
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && messages[langParam]) {
      setLanguage(langParam);
    } else {
      const browserLang = navigator.language.slice(0, 2);
      if (messages[browserLang]) setLanguage(browserLang);
    }

    // Universal Links - Spotify app opens automatically if installed
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = SPOTIFY_WEB_URL;
    } else {
      setTimeout(() => {
        setRedirecting(false);
        window.open(SPOTIFY_WEB_URL, '_blank');
      }, 1500);
    }
  }, []);

  const t = messages[language];

  const openSpotify = () => {
    window.location.href = SPOTIFY_WEB_URL;
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center relative overflow-hidden" data-testid="afternoon-landing">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg)',
          filter: 'blur(30px) brightness(0.2)',
          transform: 'scale(1.2)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center px-6 text-center max-w-md">
        {/* Artwork */}
        <div className="w-56 h-56 mb-8 rounded-xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.6)] border border-white/10">
          <img
            src="https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg"
            alt={t.title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Track info */}
        <h1 className="text-2xl font-light tracking-wide mb-1">{t.title}</h1>
        <p className="text-white/40 text-sm tracking-[0.2em] mb-8">{t.subtitle}</p>

        {/* Redirecting state */}
        {redirecting && (
          <div className="mb-6 flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-white/50 text-sm">{t.redirecting}</span>
          </div>
        )}

        {/* Spotify button */}
        <button
          onClick={openSpotify}
          data-testid="spotify-deeplink-button"
          className="flex items-center gap-3 bg-[#1DB954] hover:bg-[#1ed760] text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_4px_20px_rgba(29,185,84,0.3)] mb-4"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
          </svg>
          {t.button}
        </button>

        {/* Fallback text */}
        {!redirecting && (
          <p className="text-white/30 text-xs mb-8">{t.fallback}</p>
        )}

        {/* Back to site */}
        <a
          href="/#music"
          className="text-white/30 text-xs tracking-[0.15em] hover:text-white/60 transition-colors duration-300 mt-4 border-b border-white/10 pb-1"
        >
          {t.explore}
        </a>

        {/* Branding */}
        <p className="text-white/15 text-[10px] tracking-[0.3em] mt-12">SYNTETIK WORLD</p>
      </div>
    </div>
  );
};

export default AfternoonLanding;
